import { createFileRoute } from '@tanstack/react-router'
import { Stack } from '@astryxdesign/core/Stack'
import { Text } from '@astryxdesign/core/Text'
import { DocumentVault } from '#/components/DocumentVault'
import { useMe, useTrip, useUsers } from '#/lib/hooks'
import { isAdmin } from '#/lib/types'

export const Route = createFileRoute('/manage/documents')({ component: Documents })

/**
 * Co-travellers read the vault — the point of a shared one is that someone
 * else can pull up the hotel voucher — but only admins add or remove.
 */
function Documents() {
  const trip = useTrip()
  const users = useUsers()
  const me = useMe()

  return (
    <Stack direction="vertical" gap={4}>
      <Stack direction="vertical" gap={0}>
        <Text type="display-3" display="block">Documents</Text>
        <Text type="supporting">
          Passports and citizenship are kept across every trip. Tickets and
          vouchers belong to one.
        </Text>
      </Stack>
      <DocumentVault trip={trip} users={users} canEdit={isAdmin(me?.role)} />
    </Stack>
  )
}
